module.exports = __webpack_public_path__ + "static/img/new_active.df594ed5.jpg";